import {
  UPDATE_PROJECT_CORRESPONDENCE_ENTRY_REQUEST,
  UPDATE_PROJECT_CORRESPONDENCE_ENTRY_ERROR,
  UPDATE_PROJECT_CORRESPONDENCE_ENTRY_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/updateEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (entity, entityTableData) => (state = initialState, action) => {

  context.init(context);

  context.UPDATE_ENTITY_REQUEST = UPDATE_PROJECT_CORRESPONDENCE_ENTRY_REQUEST;
  context.UPDATE_ENTITY_ERROR = UPDATE_PROJECT_CORRESPONDENCE_ENTRY_ERROR;
  context.UPDATE_ENTITY_SUCCESS = UPDATE_PROJECT_CORRESPONDENCE_ENTRY_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "projectCorrespondenceEntries";
  context.entityLocation = RESOURCES.ProjectCorrespondenceEntries;

  return context.execute(context)(entity, entityTableData)(state, action);
};